import {ModalRepository} from "./modal.repository";
import { numberSystemDecimal, popUpSizes } from '../../common/consts';
import {TabControlComponent} from "../tab.control.component";
import { DownloadPlatformChaneComponent } from '../../components/download/modal.platform.change.component';
import { DownloadStore } from '../../store/download.store';
interface ModalSettings {
    descriptionColor?: string;
    [key: string]: any; // Разрешаем любые другие динамические ключи
}

export class ModalComponent {
    readonly active = 'active';
    readonly activeMobile = 'active-mobile';
    private modalSettingsItems: HTMLElement[];
    private modalContent: HTMLElement | null;
    private modalTitleTo: HTMLElement | null;
    private modalDescriptionTo: HTMLElement | null;
    private modalContentTo: HTMLElement | null;
    private modalClose: HTMLElement | null
    private modalSizeTo: HTMLElement | null;
    private modalHeaderSizeTo: HTMLElement | null;
    private settings: ModalSettings;
    constructor(
        private container: HTMLElement,
        private modalOpenItem: HTMLElement | null = null,
        private modalName: string = '',
        private tabParams: any = null,
        private loader: HTMLElement | null= null,
        private downloadStore : DownloadStore | null = null,
    ) {
    this.modalContent = container.querySelector('[data-modal-content]');
    this.modalTitleTo = this.container.querySelector('[data-modal-title-to]');
    this.modalDescriptionTo = this.container.querySelector('[data-modal-description-to]');
    this.modalContentTo = this.container.querySelector('[data-modal-content-to]');
    this.modalClose = container.querySelector('[data-modal-close]');
    this.modalSizeTo = container.querySelector('[data-modal-size-to]');
    this.modalHeaderSizeTo = container.querySelector('[data-modal-header-size-to]');
    this.modalSettingsItems
        = Array.prototype.slice.call(document.querySelectorAll('[data-modal-settings="container"]'));
        this.settings  = {};
    }
    public initialize(): void {

        this.modalSettingsItems.forEach((modalSettingsItem: HTMLElement) => {
            const modalNameElement: HTMLElement | null = modalSettingsItem.querySelector('[data-modal-name]');
            if (typeof this.modalOpenItem) {
                if (this.modalOpenItem?.dataset?.modalOpen
                  === modalNameElement?.dataset.modalName
                  || this.modalName === modalNameElement?.dataset.modalName
                ) {
                    const {
                        modalTitleFrom,
                        modalDescriptionFrom,
                        modalContentFrom,
                        modalWidth,
                        modalHeight,
                        isModalCustom,
                        modalSize,
                        modalHeaderSize,
                        modalObjectSettings
                    } = new ModalRepository(modalSettingsItem).getModalRepository();
                    this.container.classList.toggle(this.modalOpenItem?.dataset?.modalOpen === 'menu'
                      ? this.activeMobile
                      : this.active
                    );
                    setTimeout(() => {
                        this.container.classList.toggle('visible');
                    }, 100);

                    if (modalObjectSettings && modalObjectSettings?.dataset?.modalObjectSettings) {
                        this.settings = JSON.parse(modalObjectSettings.dataset.modalObjectSettings);
                    }

                    if (this.modalTitleTo && this.modalContentTo && modalContentFrom && modalTitleFrom) {
                        if (modalTitleFrom?.dataset.modalTitleFrom ===  this.modalOpenItem?.dataset.modalOpen || this.modalName) {
                            this.modalTitleTo.innerText = modalTitleFrom.innerText;
                            if (modalDescriptionFrom && this.modalDescriptionTo) {
                                this.modalDescriptionTo.classList.add('mt-10');
                                this.modalDescriptionTo.innerText = modalDescriptionFrom.innerText;

                                //
                                if (this.settings && this.settings.descriptionColor) {
                                    this.modalDescriptionTo.classList.add(this.settings.descriptionColor);
                                }
                            }
                            this.setSizeModal(modalSize);
                            this.setHeaderSizeModal(modalHeaderSize);
                        }
                        if (modalContentFrom?.dataset.modalContentFrom === this.modalOpenItem?.dataset.modalOpen || this.modalName) {
                            this.modalContentTo.innerHTML = modalContentFrom.innerHTML;
                            const event = new CustomEvent('modalContentRendered', {
                                detail: { container: this.modalContentTo }
                            });
                            document.dispatchEvent(event);
                        }
                    }
                }
            }
        })
        this.closeModal(this.settings);

        const tabControls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs="container"]'));

        if (this.tabParams) {
            const {switchers, priceStore, newsStore, searchParams} = this.tabParams;
            if (this.downloadStore) {
                tabControls.forEach((item: HTMLElement, index: number) =>
                  new TabControlComponent(
                    item,
                    index,
                    switchers,
                    priceStore,
                    newsStore,
                    searchParams,
                    this.loader,
                    this.downloadStore
                  ).initialize());
                new DownloadPlatformChaneComponent(
                  this.loader,
                  this.downloadStore.getPlatformId(),
                  this.modalContentTo,
                  this.modalOpenItem,
                ).initialize();
            }
        }

        document.addEventListener('modalClose', this.eventCloseModal.bind(this) as EventListener);
    }
    setSizeModal(modalSize: HTMLElement | null): void {
        if (this.modalContent && this.modalSizeTo) {
            if (modalSize?.dataset.modalSizeFrom) {
                this.modalContent.classList.add('modal__content--' + modalSize.dataset.modalSizeFrom);
                this.modalSizeTo.setAttribute('data-modal-size-to', modalSize.dataset.modalSizeFrom);
            } else {
                const size = popUpSizes.find(
                  (popUpSize: string ) => popUpSize === this.modalSizeTo?.dataset.modalSizeTo
                );
                this.modalSizeTo.setAttribute('data-modal-size-to', '');
                this.modalContent.classList.remove('modal__content--' + size);
            }

        }
    }
    setHeaderSizeModal(modalSize: HTMLElement | null): void {
        if (this.modalHeaderSizeTo) {
            if (modalSize?.dataset.modalHeaderSizeFrom) {
                this.modalHeaderSizeTo.classList.add('modal__header--' + modalSize.dataset.modalHeaderSizeFrom);
                this.modalHeaderSizeTo
                  .setAttribute('data-modal-header-size-to', modalSize.dataset.modalHeaderSizeFrom);
            } else {
                const size = popUpSizes.find(
                  (popUpSize: string ) => popUpSize === this.modalHeaderSizeTo?.dataset.modalHeaderSizeTo
                );
                this.modalHeaderSizeTo.setAttribute('data-modal-header-size-to', '');
                this.modalHeaderSizeTo.classList.remove('modal__header--' + size);
            }
        }
    }
    closeModal(settings: ModalSettings | null) {

        if (this.modalClose) {
            this.modalClose.addEventListener('click', (e: PointerEvent) => {
                e.stopImmediatePropagation();
                this.closeHideModal(settings);
            });
        }
        if (this.container) {
            this.container.addEventListener('click', (e: PointerEvent) => {
                const eventTarget: HTMLElement = e.target as HTMLElement
                // if (!eventTarget.closest('[data-modal-content]')) {
                //     this.closeHideModal(settings);
                // }
                if (eventTarget?.dataset?.modal) {
                    this.closeHideModal(settings);
                }
            });
        }
        const parent = this;
        document.addEventListener('keydown', function(event: KeyboardEvent) {
            if (event.key === 'Escape') {
                event.preventDefault();
                parent.closeHideModal(settings);
            }
        });
    }
    eventCloseModal() {
        this.closeHideModal(this.settings);
    }
    closeHideModal(settings: ModalSettings | null = null) {
        this.container.classList.remove('visible');
        const hideModal = () => {
            this.container.classList.remove('active');
            this.container.classList.remove('active-mobile');
            this.container.removeEventListener('transitionend', hideModal);
            if (this.modalDescriptionTo) {
                this.modalDescriptionTo.classList.remove('mt-10');
                if (settings?.descriptionColor) {
                    this.modalDescriptionTo.classList.remove(settings.descriptionColor);
                }

            }
        }
        this.container.addEventListener('transitionend', hideModal);
    }
}
